import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { useAuth } from "../../store/AuthContext";
import { Picker } from "./Picker";

export const DEFAULT_BODY = ["Sedan", "SWB Sedan", "LWB Sedan", "Coupe", "Hatchback", "Wagon", "4D Sportwagon", "SUV", "Crossover", "Crew Cab", "Extended Cab", "Regular Cab", "P/U", "Crew P/U", "Extended P/U", "Van", "Convertible"];

let cache = null;
const listeners = new Set();
const publish = (styles) => { cache = styles; listeners.forEach((fn) => fn(styles)); };
export const loadBodyStyles = () => api.bodyStyles().then(publish).catch(() => cache || DEFAULT_BODY.map((name) => ({ name, custom: false, in_use: false })));

export const useBodyStyles = () => {
  const [styles, setStyles] = useState(cache || DEFAULT_BODY.map((name) => ({ name, custom: false, in_use: false })));
  useEffect(() => { listeners.add(setStyles); if (!cache) loadBodyStyles(); return () => listeners.delete(setStyles); }, []);
  return styles;
};

// Body dropdown shared by Upload, Bulk import and Pattern Library. Owner: type a new body type → it's saved for everyone;
// owner-added types that no vehicle uses yet show a trash icon.
export const BodyStylePicker = ({ id, value, onChange, className = "", width, placeholder = "Body" }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const styles = useBodyStyles();
  const options = styles.map((s) => ({ value: s.name, label: s.name, hint: s.custom && !s.in_use ? "added by you" : undefined, removable: isAdmin && s.custom && !s.in_use }));
  if (value && !options.some((o) => o.value === value)) options.unshift({ value, label: value });
  const pick = async (v) => {
    if (!v || options.some((o) => o.value === v)) { onChange(v); return; }
    if (!isAdmin) { onChange(v); return; }
    try { const r = await api.adminAddBodyStyle(v); onChange(r.name); toast.success(`"${r.name}" added to the Body list`); loadBodyStyles(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const remove = async (o) => {
    try { await api.adminRemoveBodyStyle(o.value); toast.success(`"${o.value}" removed from the Body list`); loadBodyStyles(); if (value === o.value) onChange(""); }
    catch (e) { toast.error(apiError(e)); }
  };
  return <Picker id={id} value={value || ""} options={options} onChange={pick} placeholder={placeholder} searchable allowCustom={isAdmin} onRemove={isAdmin ? remove : undefined} width={width} className={className} title={isAdmin ? "Type a body type that isn't listed to add it" : undefined} />;
};
